import React, { useState } from 'react';
import { Container, Row, Col, Card, FormGroup, Label, Input, Button, CardBody, CardHeader } from 'reactstrap';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
// import { usePendingWork } from '../../../hooks/workOrder/usePendingWork';
import { usePendingExternaLabs } from '../../hooks/pendingExternaLabs/usePendingExternaLabs';
import Select from 'react-select';
import '../../views/externalLaboratory/cssPendingExternaLab.css'

// import './styleDataTable.css';

export const IndexPendingExternaLab = () => {
    const {
        // #region Filters
        mDateRange1, mDateRange2, release_mode, handleCleanLaboratory, handleClean,
        // #endregion 

        handleInputChange, handleSelectValues, loading,
        getPedingWorkLabsExternal, reportPendingExams,
        externalLaboratory, mSelectLaboratoryExt,

        //Indicators
        nameLaboratory, totalNims, totalExam,

        // search Exams
        handleSearchPedingWork,

        //excekl
        exportExcel

    } = usePendingExternaLabs();

    const [globalFilter, setGlobalFilter] = useState('');

    const releaseOptions = [
        { value: '0', label: 'Todos' },
        { value: '1', label: 'Liberados' },
        { value: '2', label: 'Pendientes de liberar' },
    ];

    return (
        <div className='container-global-zoom'>

            <Card
                style={{
                    marginBottom: "15px",
                    background: "linear-gradient(135deg, #002940 0%, #1d5b83 100%)",
                    border: "none",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.15)"
                }}
            >
                <CardBody style={{ padding: "18px 25px" }}>
                    <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                            <div
                                style={{
                                    width: "50px",
                                    height: "50px",
                                    borderRadius: "12px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    marginRight: "15px"
                                }}
                            >
                                <img alt="flask" className="img-fluid text-info mr-2" src={require("../../assets/images/laboratory-External/icon-logs.svg")} style={{ width: "60px", height: "60px" }} />

                            </div>

                            <div>
                                <h4
                                    className="mb-1"
                                    style={{
                                        color: "#fff",
                                        fontWeight: 700,
                                        fontSize: "20px",
                                        textAlign: "justify"
                                    }}
                                >
                                    Reporte de pendientes de laboratorios de referencia
                                </h4>


                                <small
                                    style={{
                                        color:
                                            "rgba(255, 255, 255, 0.85)",

                                        fontSize: "13px"
                                    }}
                                >

                                    <i className="fa fa-info-circle mr-1"></i>
                                    Reporte de seguimiento de liberación de estudios referenciados
                                </small>
                            </div>
                        </div>
                    </div>
                </CardBody>
            </Card>

            <Card className="shadow-sm border height-equal pricingtable mb-0 pb-0" style={{ padding: "5px", width: "100%" }}>
                <Col sm="12">
                    <Card className="pending-filters-card">
                        <div className="pending-filters-header">
                            <div className="pending-filters-header-title">
                                <i className="fa fa-filter"></i>
                                <span>Filtros de búsqueda</span>
                            </div>
                        </div>

                        <CardBody className="pending-filters-body">

                            <div className="pending-filters-row">
                                <FormGroup className="pending-filter-group">
                                    <Label className="pending-filter-label">
                                        <i className="fa fa-calendar"></i>
                                        Fecha de inicio
                                    </Label>

                                    <Input
                                        type="date"
                                        value={mDateRange1}
                                        name="mDateRange1"
                                        onChange={handleInputChange}
                                        className="pending-filter-input"
                                    />
                                </FormGroup>

                                <FormGroup className="pending-filter-group">
                                    <Label className="pending-filter-label">
                                        <i className="fa fa-calendar-check-o"></i>
                                        Fecha de cierre
                                    </Label>

                                    <Input
                                        type="date"
                                        value={mDateRange2}
                                        name="mDateRange2"
                                        onChange={handleInputChange}
                                        className="pending-filter-input"
                                    />
                                </FormGroup>

                                <FormGroup className="pending-filter-group">
                                    <Label className="pending-filter-label">
                                        <i className="fa fa-tasks"></i>
                                        Método de entrega
                                    </Label>

                                    <Select
                                        name="release_mode"
                                        placeholder="Selecciona un estatus"
                                        options={releaseOptions}
                                        value={release_mode}
                                        onChange={(e) =>
                                            handleSelectValues(e, "release_mode")
                                        }
                                        menuPortalTarget={document.body}
                                        styles={{
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 99999
                                            }),
                                            control: (base, state) => ({
                                                ...base,
                                                minHeight: "30px",
                                                height: "30px",
                                                borderRadius: "6px",
                                                borderColor: state.isFocused
                                                    ? "#1d5b83"
                                                    : "#cbd8e3",
                                                boxShadow: "none",
                                                fontSize: "11px",
                                                "&:hover": {
                                                    borderColor: "#1d5b83"
                                                }
                                            }),
                                            valueContainer: (base) => ({
                                                ...base,
                                                height: "28px",
                                                padding: "0 8px"
                                            }),
                                            indicatorsContainer: (base) => ({
                                                ...base,
                                                height: "28px"
                                            }),
                                            dropdownIndicator: (base) => ({
                                                ...base,
                                                padding: "5px"
                                            }),
                                            clearIndicator: (base) => ({
                                                ...base,
                                                padding: "5px"
                                            }),
                                            input: (base) => ({
                                                ...base,
                                                margin: 0,
                                                padding: 0
                                            })
                                        }}
                                    />
                                </FormGroup>

                                {/* ACCIONES */}
                                <div className="pending-filter-actions">

                                    <Label className="pending-filter-label">
                                        <i className="fa fa-cog"></i>
                                        Acciones
                                    </Label>

                                    <div className="pending-filter-buttons">
                                        <Button
                                            type="button"
                                            color="primary"
                                            outline
                                            disabled={loading}
                                            onClick={(e) =>
                                                getPedingWorkLabsExternal(e, true)
                                            }
                                            className="pending-btn-search"
                                        >
                                            Buscar
                                        </Button>

                                        <Button
                                            type="button"
                                            color="danger"
                                            outline
                                            disabled={loading}
                                            onClick={handleClean}
                                            className="pending-btn-clear"
                                        >
                                            <i className="fa fa-eraser mr-1"></i>
                                            Limpiar
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </Col>

                <Col sm="12">
                    <Row className="mb-3 report-kpi-row">
                        <Col sm="4">
                            <div className="report-kpi report-kpi-blue">
                                <div className="report-kpi-decoration"></div>
                                <div className="report-kpi-info">
                                    <div className="report-kpi-title">
                                        <span className="report-kpi-dot"></span>
                                        Laboratorio
                                    </div>

                                    <div className="report-name-laboratory-external">
                                        {
                                            loading && <i className="fa fa-spin fa-spinner font-primary f-24"></i>
                                        }
                                        {
                                            <div>
                                                {!loading && nameLaboratory()}
                                            </div>
                                        }
                                    </div>

                                    <div className="report-kpi-footer">
                                        <i className="fa fa-file-text-o"></i>
                                        Laboratorio seleccionado
                                    </div>
                                </div>

                                <div className="report-kpi-icon">
                                    <i className="fa fa-university"></i>
                                </div>
                            </div>
                        </Col>

                        <Col sm="4">
                            <div className="report-kpi report-kpi-green">
                                <div className="report-kpi-decoration"></div>
                                <div className="report-kpi-info">
                                    <div className="report-kpi-title">
                                        <span className="report-kpi-dot"></span>
                                        Pacientes
                                    </div>

                                    <div className="report-kpi-number">
                                        {
                                            loading && <i className="fa fa-spin fa-spinner font-primary f-24"></i>
                                        }
                                        {
                                            <div>
                                                {!loading && totalNims()}
                                            </div>
                                        }
                                    </div>

                                    <div className="report-kpi-footer">
                                        <i className="fa fa-check-circle-o"></i>
                                        Total de pacientes
                                    </div>
                                </div>

                                <div className="report-kpi-icon">
                                    <i className="fa fa-users"></i>
                                </div>
                            </div>
                        </Col>

                        <Col sm="4">
                            <div className="report-kpi report-kpi-orange">
                                <div className="report-kpi-decoration"></div>
                                <div className="report-kpi-info">
                                    <div className="report-kpi-title">
                                        <span className="report-kpi-dot"></span>
                                        Examenes
                                    </div>

                                    <div className="report-kpi-number">
                                        {
                                            loading && <i className="fa fa-spin fa-spinner font-primary f-24"></i>
                                        }
                                        {
                                            <div>
                                                {!loading && totalExam()}
                                            </div>
                                        }

                                    </div>

                                    <div className="report-kpi-footer">
                                        <i className="fa fa-line-chart"></i>
                                        Total de examenes
                                    </div>
                                </div>

                                <div className="report-kpi-icon">
                                    <i className="fa fa-flask"></i>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Col>

                <Col sm="12" className="pt-3">
                    <Row>
                        <Col sm="4">
                            <Card className="reference-labs-card">
                                <div className="reference-labs-header">
                                    <div className="reference-labs-heading">
                                        <i className="fa fa-building-o"></i>
                                        <span>Laboratorios de referencia</span>
                                    </div>

                                    <button
                                        type="button"
                                        className="reference-labs-clear"
                                        onClick={handleCleanLaboratory}
                                        title="Limpiar selección"
                                    >
                                        <i className="fa fa-eraser"></i>
                                    </button>
                                </div>

                                <CardBody className="reference-labs-body">

                                    <div className="reference-labs-summary">
                                        <span>Selecciona un laboratorio</span>

                                        <span className="reference-labs-count">
                                            {externalLaboratory.length} disponibles
                                        </span>
                                    </div>

                                    {externalLaboratory.length > 0 ? (
                                        <div className="reference-labs-grid">

                                            {externalLaboratory.map((laboratory) => {

                                                const isSelected =
                                                    mSelectLaboratoryExt?.value ===
                                                    laboratory.value;

                                                return (
                                                    <button
                                                        type="button"
                                                        key={laboratory.value}
                                                        title={laboratory.label}
                                                        aria-pressed={isSelected}
                                                        className={`reference-labs-item ${
                                                            isSelected ? "is-selected" : ""
                                                        }`}
                                                        onClick={() => {
                                                            handleSelectValues(
                                                                laboratory,
                                                                "mSelectLaboratoryExt"
                                                            );
                                                        }}
                                                    >
                                                        {isSelected && (
                                                            <i className="fa fa-check-circle"></i>
                                                        )}

                                                        <span>{laboratory.label}</span>
                                                    </button>
                                                );
                                            })}

                                        </div>
                                    ) : (
                                        <div className="reference-labs-empty">
                                            <i className="fa fa-building-o"></i>
                                            <span>
                                                No hay laboratorios disponibles
                                            </span>
                                        </div>
                                    )}

                                </CardBody>
                            </Card>
                        </Col>

                        <Col sm="8">
                            <div className="report-table-card">
                                <div className="report-table-toolbar">
                                    <div className="report-table-title">
                                        <div className="report-table-title-icon">
                                            <i className="fa fa-list-ul"></i>
                                        </div>

                                        <div>
                                            <h5>Detallado de laboratorios</h5>
                                        </div>
                                    </div>

                                    <div className="report-table-actions">
                                          <button
                                                className="p-button p-button-success"
                                                onClick={() => exportExcel()}
                                                title="Reporte de laboratorios externos"
                                                style={{
                                                    alignItems: "center",
                                                    padding: "5px 8px",
                                                    height: "35px",
                                                    width: "35px",
                                                    fontSize: "0.9rem",
                                                }}
                                            >
                                                <i className="pi pi-file-excel" style={{ fontSize: "1rem", marginRight: "5px" }}></i>
                                            </button>
                                        <div className="report-general-search">
                                            <i className="pi pi-search"></i>

                                            <Input
                                                type="search"
                                                placeholder="Buscar en todos los registros..."
                                                // value={searchTerm}
                                                onChange={handleSearchPedingWork}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className='table-responsive'>
                                    <DataTable
                                        value={reportPendingExams}
                                        stripedRows
                                        paginator
                                        rows={10}
                                        rowsPerPageOptions={[10, 50, 100]}
                                        className="data-table p-datatable-striped p-datatable-sm"
                                        responsiveLayout="scroll"
                                        globalFilter={globalFilter}
                                        emptyMessage={
                                            <div className="text-center">
                                                <img
                                                    src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                                    style={{ width: "25%" }}
                                                    alt="Sin resultados"
                                                />
                                                <br />
                                                <p className='badge badge-light-primary mt-2' style={{ fontSize: "15px" }}>
                                                    Sin información de pendientes de laboratorio.
                                                </p>
                                            </div>
                                        }
                                    >
                                        {/* Columna índice */}
                                        <Column
                                            header="#"
                                            body={(rowData, { rowIndex }) => rowIndex + 1}
                                            style={{ width: '3em', textAlign: 'center', fontSize: "12px" }}
                                            headerStyle={{ backgroundColor: "#1d5b83", color: "#fff", fontWeight: "bold", fontSize: "12px", textAlign: 'center' }}
                                        />

                                        <Column
                                            field="laboratory"
                                            header="Laboratorio"
                                            headerStyle={{ backgroundColor: "#1d5b83", color: "#fff", fontWeight: "bold", fontSize: "12px", textAlign: 'center' }}
                                            style={{ fontSize: "12px", textAlign: 'center' }}
                                        />

                                        <Column
                                            field="nim"
                                            header="NIM"
                                            body={(rowData) => (
                                                <a
                                                    href={`/captura-resultados/${rowData.nim}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    {rowData.nim}
                                                </a>
                                            )}
                                            headerStyle={{ backgroundColor: "#1d5b83", color: "#fff", fontWeight: "bold", fontSize: "12px" }}
                                            style={{ fontSize: "12px", textAlign: 'center' }}
                                        />


                                        <Column
                                            header="Nombre del Paciente"
                                            body={(rowData) => `${rowData.name} ${rowData.paternal_surname} ${rowData.maternal_surname}`}
                                            headerStyle={{ backgroundColor: "#1d5b83", color: "#fff", fontWeight: "bold", fontSize: "12px", textAlign: 'center' }}
                                            style={{ fontSize: "12px", textAlign: 'center' }}

                                        />


                                        <Column
                                            field="exam"
                                            header="Exámen"
                                            headerStyle={{ backgroundColor: "#1d5b83", color: "#fff", fontWeight: "bold", fontSize: "12px" }}
                                            style={{ fontSize: "12px", textAlign: 'center' }}
                                        />

                                        <Column
                                            field="cost"
                                            header="Costo"
                                            sortable
                                            headerStyle={{ backgroundColor: "#1d5b83", color: "#fff", fontWeight: "bold", fontSize: "12px" }}
                                            style={{ fontSize: "12px", textAlign: 'center' }}
                                            body={(rowData) => {
                                                const cost = parseFloat(rowData.cost);
                                                return isNaN(cost) ? '' : `$${cost.toFixed(2)}`;
                                            }}

                                        />


                                        <Column
                                            field="study_delivery"
                                            header="Fecha promesa"
                                            headerStyle={{ backgroundColor: "#1d5b83", color: "#fff", fontWeight: "bold", fontSize: "12px" }}
                                            style={{ fontSize: "12px", textAlign: 'center' }}
                                        />




                                        <Column
                                            field="price"
                                            header="Precio"
                                            sortable
                                            headerStyle={{ backgroundColor: "#1d5b83", color: "#fff", fontWeight: "bold", fontSize: "12px" }}
                                            style={{ fontSize: "12px", textAlign: 'center' }}
                                            body={(rowData) => {
                                                const price = parseFloat(rowData.price);
                                                return isNaN(price) ? '' : `$${price.toFixed(2)}`;
                                            }}

                                        />

                                        <Column
                                            field="released"
                                            header="Estatus"
                                            sortable
                                            headerStyle={{ backgroundColor: "#1d5b83", color: "#fff", fontWeight: "bold", fontSize: "12px" }}
                                            style={{ fontSize: "12px", textAlign: 'center' }}
                                            body={(rowData) => (
                                                <span className={`badge ${rowData.released ? 'badge-success' : 'badge-warning'}`}>
                                                    {rowData.released ? 'Liberado' : 'Pendiente de liberar'}
                                                </span>
                                            )}
                                        />

                                    </DataTable>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Col>
            </Card>

             <br /><br /> <br />
        </div>
    );
};
